<template>
  <div>
    <CardContainer>
      <CommonForm slot="header" @search="formSearch" :form-json="formjson" />
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        :needIndex="true"
        @change="handleTableChange"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
      >
      </CommonTable>
    </CardContainer>
    <Detail :row="row" v-if="visible" @refresh="formSearch" :visible.sync="visible" />
  </div>
</template>

<script>
import formjson from './Model/Formjson.Index'
import tablejson from './Model/Tablejson.Index'
import formTableMixin from '@younuo/mixins/formTableMixin'
import Detail from './detail'
export default {
  mixins: [formTableMixin],
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        {
          name: '详情',
          type: 'detail'
        }
      ],
      queryApi: this.$api.wine.app_user_list,
      visible: false,
      row: {}
    }
  },
  components: {
    Detail
  },
  methods: {
    formSearch(data) {
      this.search(data, null, this.queryApi)
    },
    handleDetail(row) {
      this.row = row
      this.visible = true
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'detail':
          this.handleDetail(row)
          break
      }
    }
  }
}
</script>
<style lang="less"></style>
